export default {
  notifications: (state) => state.notifications,
  lastSeen: (state) => state.lastSeen,
}
